// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!./AssessmentDefaults.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ParticipantAssessments_pageHeader__oAISj {
  display: grid;
  grid-template-areas: "header actions";
  grid-template-columns: 50% 50%;
  grid-gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.ParticipantAssessments_pageHeaderText__8Uxku {
  grid-area: header;
}

.ParticipantAssessments_pageHeaderActions__SvTql {
  grid-area: actions;
  display: flex;
  justify-content: flex-end;
  align-items: top;
}

.ParticipantAssessments_pageHeaderActionButton__LRCVA {
  color: #fff !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
  padding: 16px 24px !important;
  border-radius: 28px !important;
  height: 50px;
  margin-top: -5px;
}

.ParticipantAssessments_orgSelector__VDjQ9 {
  width: fit-content;
  max-width: 400px;
  min-width: 200px;
}

.ParticipantAssessments_orgSelectorMobile__pZ9P- {
  display: none;
  width: 100%;
}

.ParticipantAssessments_OverviewLayout__bHD0I {
  display: grid;
  grid-template-areas:
    "header action"
    "summary summary"
    "summary2 summary2"
    "graph graph"
    "table table";
  width: 100%;
  align-items: center;
}

.ParticipantAssessments_OverviewLayoutHeader__kujT2 {
  grid-area: header;
  display: flex;
  align-items: center;
  margin-bottom: var(--sectionMarginBottom);
}

.ParticipantAssessments_OverviewLayoutAction__pf4A\\+ {
  grid-area: action;
  display: flex;
  justify-content: flex-end;
  align-items: normal;
  width: 100%;
  margin-bottom: var(--sectionMarginBottom);
}

.ParticipantAssessments_OverviewLayoutAction__pf4A\\+ .p-dropdown {
  margin-top: 0px;
  height: max-content;
}

.ParticipantAssessments_OverviewLayoutActionPartial__Hol3l {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.ParticipantAssessments_OverviewLayoutSummary__ZT6bN,
.ParticipantAssessments_OverviewLayoutSummary2__I2c5R {
  display: flex;
  border: 15px var(--lightPurple) solid;
  gap: 10px;
  border-radius: 10px;
  background-color: var(--lightPurple);
  margin-bottom: var(--sectionMarginBottom);
}

.ParticipantAssessments_OverviewLayoutSummary__ZT6bN {
  grid-area: summary;
}

.ParticipantAssessments_OverviewLayoutSummary2__I2c5R {
  grid-area: summary2;
}

.ParticipantAssessments_summaryMarginBottom__d\\+01j {
  margin-bottom: 10px;
}

.ParticipantAssessments_OverviewLayoutGraph__yYdFz {
  grid-area: graph;
  margin-bottom: var(--sectionMarginBottom);
}

.ParticipantAssessments_OverviewLayoutTable__-OJE0 {
  grid-area: table;
  margin-bottom: var(--sectionMarginBottom);
}

.ParticipantAssessments_overviewSummaryLayout__ibeFZ {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  width: 100%;
  border-radius: 10px;
  background-color: white;
  align-self: stretch;
  padding: 15px;
}

.ParticipantAssessments_overviewSummaryLayoutLogo__\\+V83N {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background-color: #debeed80;
  width: 30px;
  height: 30px;
  color: var(--branded-purple);
  margin-right: 8px;
}

.ParticipantAssessments_overviewSummaryLayoutDescription__SoEub {
  display: flex;
  align-items: flex-end;
  font-weight: 600;
}

.ParticipantAssessments_overviewSummaryLayoutCounter__\\+J3xH {
  display: flex;
  align-items: flex-start;
  font-weight: 400;
}

.ParticipantAssessments_overviewGraphLayout__3nMLH {
  display: grid;
  grid-template-areas:
    "header period type"
    "graph graph graph";
  width: 100%;
  grid-gap: 10px;
  padding: 10px;
}

.ParticipantAssessments_overviewGraphLayoutHeader__1b4cy {
  grid-area: header;
  font-weight: bold;
  font-size: larger;
  display: flex;
  align-items: center;
}

.ParticipantAssessments_overviewGraphLayoutPeriod__-h7-R {
  grid-area: period;
}

.ParticipantAssessments_overviewGraphLayoutType__fZ-hV {
  grid-area: type;
}

.ParticipantAssessments_overviewGraphLayoutGraph__Yap7K {
  grid-area: graph;
}

.ParticipantAssessments_overviewGraphLayoutGraph__Yap7K .p-chart {
  height: 300px;
}

.ParticipantAssessments_overviewGraphDropDown__PutNO {
  width: 100%;
}

.ParticipantAssessments_graphHelper__CfXjO {
  font-size: small;
}

.ParticipantAssessments_completedLayout__a46OH {
  display: grid;
  grid-template-areas:
    "header filters sort"
    "body body body";
  grid-template-columns: auto auto auto;
  width: 100%;
}

.ParticipantAssessments_completedLayoutHeader__gIju5 {
  grid-area: header;
}

.ParticipantAssessments_headerCompletedAssessments__LYDFs {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 0px;
}

.ParticipantAssessments_completedLayoutFilters__JGtfK {
  justify-content: space-between;
  margin-bottom: 5px;
  width: 100%;
}

.ParticipantAssessments_completedLayoutRefresh__jywZi {
  display: flex;
  justify-content: flex-end;
  padding-top: 2px;
  margin-bottom: 5px;
  width: fit-content;
}

.ParticipantAssessments_completedLayoutBody__nJMxn {
  grid-area: body;
}

.ParticipantAssessments_completedComponent__AjQZB {
  width: 100%;
}

.ParticipantAssessments_actionButton__JHay2 {
  background: transparent;
  color: var(--branded-purple);
  border: solid 1px;
  border-radius: 10px;
}

.ParticipantAssessments_actionButton__JHay2 .p-button {
  background-color: #debeed80;
}

.ParticipantAssessments_filterButtonText__vvdnr {
  padding-right: 10px;
}

.ParticipantAssessments_filterDialog__Zahmp {
  width: 550px;
}

.ParticipantAssessments_filterControl__LdxHy {
  width: 100%;
}

.ParticipantAssessments_filterLayout__Ebmo2 {
  display: grid;
  grid-template-areas:
    "createdFrom createdTo"
    "search search"
    "reset buttons";
  width: 100%;
  grid-template-columns: 50% 50%;
  grid-gap: 10px;
}

.ParticipantAssessments_filterLayoutSchedule__hG2kt {
  display: grid;
  grid-template-areas:
    "createdFrom createdFrom createdTo createdTo"
    "search search search search"
    "completed completedInput upcoming upcomingInput"
    "reset reset buttons buttons";
  width: 100%;
  grid-template-columns: 35% 13% 35% 13%;
  grid-gap: 10px;
}

.ParticipantAssessments_filterLayoutFromScheduleCompleted__J\\+KUg {
  grid-area: completed;
  display: flex;
  align-items: center;
}

.ParticipantAssessments_filterLayoutFromScheduleCompletedInput__p76gW {
  grid-area: completedInput;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.ParticipantAssessments_filterLayoutFromScheduleUpcoming__3Q\\+Tx {
  grid-area: upcoming;
  display: flex;
  align-items: center;
}

.ParticipantAssessments_filterLayoutFromScheduleUpcomingInput__vMOJ8 {
  grid-area: upcomingInput;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.ParticipantAssessments_filterLayoutFrom__\\+vUOh {
  grid-area: createdFrom;
}

.ParticipantAssessments_filterLayoutTo__zycQ- {
  grid-area: createdTo;
}

.ParticipantAssessments_filterLayoutSearch__BrTVs {
  grid-area: search;
}

.ParticipantAssessments_filterLayoutReset__T9rbF {
  grid-area: reset;
}

.ParticipantAssessments_filterLayoutButtons__AZw-f {
  grid-area: buttons;
  display: flex;
  justify-content: flex-end;
}

.ParticipantAssessments_blockDialog__A-gEM {
  max-width: calc(100vw - 20px);
  width: 800px;
}

.ParticipantAssessments_blockFooter__GCeb8 {
  position: sticky;
  bottom: -15px;
  display: flex;
  justify-content: right;
  width: 100%;
  height: 60px;
  background-color: white;
  padding-top: 10px;
}

.ParticipantAssessments_buttonGroup__yNYQT {
  display: flex;
}

.ParticipantAssessments_InfoOverlayIconContainer__q0jAU {
  margin-left: 0px;
  margin-right: 0px;
}

.ParticipantAssessments_InfoOverlay__BWrJ7 {
  background-color: transparent;
  border: solid black 1px;
}

.ParticipantAssessments_InfoOverlayText__a5uWj {
  color: white;
}

.ParticipantAssessments_refreshContainer__uq4UL {
  position: relative;
}

.ParticipantAssessments_refreshButton__dYZSw {
  background-color: #efdff6 !important;
  color: var(--branded-purple);
  border: 0px !important;
  rotate: 90deg;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
  margin-left: 10px;
  margin-right: 0px;
}

.ParticipantAssessments_refreshBadge__eR3Ik {
  position: absolute;
  top: -10px;
  right: 2px;
}

.ParticipantAssessments_viewSelect__LJ7kl {
  width: fit-content;
  max-width: 400px;
  min-width: 200px;
}

.ParticipantAssessments_tabView__qS1tW {
  display: block;
}

.ParticipantAssessments_tabViewMobile__22N4A {
  display: none;
}

.ParticipantAssessments_tabButtonContainer__Oqbxa {
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  margin-top: 10px;
}

.ParticipantAssessments_viewButton__ZCS9H {
  flex: 1 1;
  height: 80px;
  background-color: white;
  border-radius: 10px;
}

.ParticipantAssessments_viewButtonContent__awsPe {
  flex-direction: column;
  width: 100%;
  color: #383838;
  font-size: 14px;
}

.ParticipantAssessments_viewButtonContentSelected__dhy1f {
  color: var(--branded-purple);
  font-weight: bold;
}

/* tablet */
@media (min-width: 768px) and (max-width: 1024px) {
}

/* mobile */
@media (max-width: 768px) {
  .ParticipantAssessments_OverviewLayout__bHD0I {
    grid-template-areas:
      "header header"
      "action action"
      "summary summary"
      "summary2 summary2"
      "graph graph"
      "table table";
  }

  .ParticipantAssessments_OverviewLayoutAction__pf4A\\+ {
    justify-content: flex-start;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .ParticipantAssessments_OverviewLayoutActionPartial__Hol3l {
    flex-direction: row-reverse;
  }

  .ParticipantAssessments_OverviewLayoutSummary__ZT6bN,
  .ParticipantAssessments_OverviewLayoutSummary2__I2c5R {
    flex-direction: column;
  }

  .ParticipantAssessments_orgSelector__VDjQ9 {
    display: none;
    width: fit-content;
    max-width: 400px;
    min-width: 200px;
  }

  .ParticipantAssessments_orgSelectorMobile__pZ9P- {
    display: flex;
    width: 100%;
  }

  .ParticipantAssessments_tabView__qS1tW {
    display: none;
  }

  .ParticipantAssessments_tabViewMobile__22N4A {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 15px;
  }

  .ParticipantAssessments_completedLayoutFilters__JGtfK {
    margin-bottom: 0px;
  }

  .ParticipantAssessments_blockDialog__A-gEM {
    width: calc(100vw - 20px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/assessments/ParticipantAssessments.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb;;;;;iBAKe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb;;uBAEqB;EACrB,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb;;oBAEkB;EAClB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb;;;mBAGiB;EACjB,WAAW;EACX,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb;;;;iCAI+B;EAC/B,WAAW;EACX,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,WAAW;AACX;AACA;;AAEA,WAAW;AACX;EACE;IACE;;;;;;mBAMe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import \"./AssessmentDefaults.css\";\n\n.pageHeader {\n  display: grid;\n  grid-template-areas: \"header actions\";\n  grid-template-columns: 50% 50%;\n  grid-gap: 10px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.pageHeaderText {\n  grid-area: header;\n}\n\n.pageHeaderActions {\n  grid-area: actions;\n  display: flex;\n  justify-content: flex-end;\n  align-items: top;\n}\n\n.pageHeaderActionButton {\n  color: #fff !important;\n  font-size: 16px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: normal !important;\n  padding: 16px 24px !important;\n  border-radius: 28px !important;\n  height: 50px;\n  margin-top: -5px;\n}\n\n.orgSelector {\n  width: fit-content;\n  max-width: 400px;\n  min-width: 200px;\n}\n\n.orgSelectorMobile {\n  display: none;\n  width: 100%;\n}\n\n.OverviewLayout {\n  display: grid;\n  grid-template-areas:\n    \"header action\"\n    \"summary summary\"\n    \"summary2 summary2\"\n    \"graph graph\"\n    \"table table\";\n  width: 100%;\n  align-items: center;\n}\n\n.OverviewLayoutHeader {\n  grid-area: header;\n  display: flex;\n  align-items: center;\n  margin-bottom: var(--sectionMarginBottom);\n}\n\n.OverviewLayoutAction {\n  grid-area: action;\n  display: flex;\n  justify-content: flex-end;\n  align-items: normal;\n  width: 100%;\n  margin-bottom: var(--sectionMarginBottom);\n}\n\n.OverviewLayoutAction :global(.p-dropdown) {\n  margin-top: 0px;\n  height: max-content;\n}\n\n.OverviewLayoutActionPartial {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n\n.OverviewLayoutSummary,\n.OverviewLayoutSummary2 {\n  display: flex;\n  border: 15px var(--lightPurple) solid;\n  gap: 10px;\n  border-radius: 10px;\n  background-color: var(--lightPurple);\n  margin-bottom: var(--sectionMarginBottom);\n}\n\n.OverviewLayoutSummary {\n  grid-area: summary;\n}\n\n.OverviewLayoutSummary2 {\n  grid-area: summary2;\n}\n\n.summaryMarginBottom {\n  margin-bottom: 10px;\n}\n\n.OverviewLayoutGraph {\n  grid-area: graph;\n  margin-bottom: var(--sectionMarginBottom);\n}\n\n.OverviewLayoutTable {\n  grid-area: table;\n  margin-bottom: var(--sectionMarginBottom);\n}\n\n.overviewSummaryLayout {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n  border-radius: 10px;\n  background-color: white;\n  align-self: stretch;\n  padding: 15px;\n}\n\n.overviewSummaryLayoutLogo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  background-color: #debeed80;\n  width: 30px;\n  height: 30px;\n  color: var(--branded-purple);\n  margin-right: 8px;\n}\n\n.overviewSummaryLayoutDescription {\n  display: flex;\n  align-items: flex-end;\n  font-weight: 600;\n}\n\n.overviewSummaryLayoutCounter {\n  display: flex;\n  align-items: flex-start;\n  font-weight: 400;\n}\n\n.overviewGraphLayout {\n  display: grid;\n  grid-template-areas:\n    \"header period type\"\n    \"graph graph graph\";\n  width: 100%;\n  grid-gap: 10px;\n  padding: 10px;\n}\n\n.overviewGraphLayoutHeader {\n  grid-area: header;\n  font-weight: bold;\n  font-size: larger;\n  display: flex;\n  align-items: center;\n}\n\n.overviewGraphLayoutPeriod {\n  grid-area: period;\n}\n\n.overviewGraphLayoutType {\n  grid-area: type;\n}\n\n.overviewGraphLayoutGraph {\n  grid-area: graph;\n}\n\n.overviewGraphLayoutGraph :global(.p-chart) {\n  height: 300px;\n}\n\n.overviewGraphDropDown {\n  width: 100%;\n}\n\n.graphHelper {\n  font-size: small;\n}\n\n.completedLayout {\n  display: grid;\n  grid-template-areas:\n    \"header filters sort\"\n    \"body body body\";\n  grid-template-columns: auto auto auto;\n  width: 100%;\n}\n\n.completedLayoutHeader {\n  grid-area: header;\n}\n\n.headerCompletedAssessments {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  gap: 0px;\n}\n\n.completedLayoutFilters {\n  justify-content: space-between;\n  margin-bottom: 5px;\n  width: 100%;\n}\n\n.completedLayoutRefresh {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 2px;\n  margin-bottom: 5px;\n  width: fit-content;\n}\n\n.completedLayoutBody {\n  grid-area: body;\n}\n\n.completedComponent {\n  width: 100%;\n}\n\n.actionButton {\n  background: transparent;\n  color: var(--branded-purple);\n  border: solid 1px;\n  border-radius: 10px;\n}\n\n.actionButton :global(.p-button) {\n  background-color: #debeed80;\n}\n\n.filterButtonText {\n  padding-right: 10px;\n}\n\n.filterDialog {\n  width: 550px;\n}\n\n.filterControl {\n  width: 100%;\n}\n\n.filterLayout {\n  display: grid;\n  grid-template-areas:\n    \"createdFrom createdTo\"\n    \"search search\"\n    \"reset buttons\";\n  width: 100%;\n  grid-template-columns: 50% 50%;\n  grid-gap: 10px;\n}\n\n.filterLayoutSchedule {\n  display: grid;\n  grid-template-areas:\n    \"createdFrom createdFrom createdTo createdTo\"\n    \"search search search search\"\n    \"completed completedInput upcoming upcomingInput\"\n    \"reset reset buttons buttons\";\n  width: 100%;\n  grid-template-columns: 35% 13% 35% 13%;\n  grid-gap: 10px;\n}\n\n.filterLayoutFromScheduleCompleted {\n  grid-area: completed;\n  display: flex;\n  align-items: center;\n}\n\n.filterLayoutFromScheduleCompletedInput {\n  grid-area: completedInput;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.filterLayoutFromScheduleUpcoming {\n  grid-area: upcoming;\n  display: flex;\n  align-items: center;\n}\n\n.filterLayoutFromScheduleUpcomingInput {\n  grid-area: upcomingInput;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.filterLayoutFrom {\n  grid-area: createdFrom;\n}\n\n.filterLayoutTo {\n  grid-area: createdTo;\n}\n\n.filterLayoutSearch {\n  grid-area: search;\n}\n\n.filterLayoutReset {\n  grid-area: reset;\n}\n\n.filterLayoutButtons {\n  grid-area: buttons;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.blockDialog {\n  max-width: calc(100vw - 20px);\n  width: 800px;\n}\n\n.blockFooter {\n  position: sticky;\n  bottom: -15px;\n  display: flex;\n  justify-content: right;\n  width: 100%;\n  height: 60px;\n  background-color: white;\n  padding-top: 10px;\n}\n\n.buttonGroup {\n  display: flex;\n}\n\n.InfoOverlayIconContainer {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n.InfoOverlay {\n  background-color: transparent;\n  border: solid black 1px;\n}\n\n.InfoOverlayText {\n  color: white;\n}\n\n.refreshContainer {\n  position: relative;\n}\n\n.refreshButton {\n  background-color: #efdff6 !important;\n  color: var(--branded-purple);\n  border: 0px !important;\n  rotate: 90deg;\n  height: 40px;\n  width: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1px;\n  margin-left: 10px;\n  margin-right: 0px;\n}\n\n.refreshBadge {\n  position: absolute;\n  top: -10px;\n  right: 2px;\n}\n\n.viewSelect {\n  width: fit-content;\n  max-width: 400px;\n  min-width: 200px;\n}\n\n.tabView {\n  display: block;\n}\n\n.tabViewMobile {\n  display: none;\n}\n\n.tabButtonContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.viewButton {\n  flex: 1;\n  height: 80px;\n  background-color: white;\n  border-radius: 10px;\n}\n\n.viewButtonContent {\n  flex-direction: column;\n  width: 100%;\n  color: #383838;\n  font-size: 14px;\n}\n\n.viewButtonContentSelected {\n  color: var(--branded-purple);\n  font-weight: bold;\n}\n\n/* tablet */\n@media (min-width: 768px) and (max-width: 1024px) {\n}\n\n/* mobile */\n@media (max-width: 768px) {\n  .OverviewLayout {\n    grid-template-areas:\n      \"header header\"\n      \"action action\"\n      \"summary summary\"\n      \"summary2 summary2\"\n      \"graph graph\"\n      \"table table\";\n  }\n\n  .OverviewLayoutAction {\n    justify-content: flex-start;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .OverviewLayoutActionPartial {\n    flex-direction: row-reverse;\n  }\n\n  .OverviewLayoutSummary,\n  .OverviewLayoutSummary2 {\n    flex-direction: column;\n  }\n\n  .orgSelector {\n    display: none;\n    width: fit-content;\n    max-width: 400px;\n    min-width: 200px;\n  }\n\n  .orgSelectorMobile {\n    display: flex;\n    width: 100%;\n  }\n\n  .tabView {\n    display: none;\n  }\n\n  .tabViewMobile {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    margin-top: 15px;\n  }\n\n  .completedLayoutFilters {\n    margin-bottom: 0px;\n  }\n\n  .blockDialog {\n    width: calc(100vw - 20px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `ParticipantAssessments_pageHeader__oAISj`,
	"pageHeaderText": `ParticipantAssessments_pageHeaderText__8Uxku`,
	"pageHeaderActions": `ParticipantAssessments_pageHeaderActions__SvTql`,
	"pageHeaderActionButton": `ParticipantAssessments_pageHeaderActionButton__LRCVA`,
	"orgSelector": `ParticipantAssessments_orgSelector__VDjQ9`,
	"orgSelectorMobile": `ParticipantAssessments_orgSelectorMobile__pZ9P-`,
	"OverviewLayout": `ParticipantAssessments_OverviewLayout__bHD0I`,
	"OverviewLayoutHeader": `ParticipantAssessments_OverviewLayoutHeader__kujT2`,
	"OverviewLayoutAction": `ParticipantAssessments_OverviewLayoutAction__pf4A+`,
	"OverviewLayoutActionPartial": `ParticipantAssessments_OverviewLayoutActionPartial__Hol3l`,
	"OverviewLayoutSummary": `ParticipantAssessments_OverviewLayoutSummary__ZT6bN`,
	"OverviewLayoutSummary2": `ParticipantAssessments_OverviewLayoutSummary2__I2c5R`,
	"summaryMarginBottom": `ParticipantAssessments_summaryMarginBottom__d+01j`,
	"OverviewLayoutGraph": `ParticipantAssessments_OverviewLayoutGraph__yYdFz`,
	"OverviewLayoutTable": `ParticipantAssessments_OverviewLayoutTable__-OJE0`,
	"overviewSummaryLayout": `ParticipantAssessments_overviewSummaryLayout__ibeFZ`,
	"overviewSummaryLayoutLogo": `ParticipantAssessments_overviewSummaryLayoutLogo__+V83N`,
	"overviewSummaryLayoutDescription": `ParticipantAssessments_overviewSummaryLayoutDescription__SoEub`,
	"overviewSummaryLayoutCounter": `ParticipantAssessments_overviewSummaryLayoutCounter__+J3xH`,
	"overviewGraphLayout": `ParticipantAssessments_overviewGraphLayout__3nMLH`,
	"overviewGraphLayoutHeader": `ParticipantAssessments_overviewGraphLayoutHeader__1b4cy`,
	"overviewGraphLayoutPeriod": `ParticipantAssessments_overviewGraphLayoutPeriod__-h7-R`,
	"overviewGraphLayoutType": `ParticipantAssessments_overviewGraphLayoutType__fZ-hV`,
	"overviewGraphLayoutGraph": `ParticipantAssessments_overviewGraphLayoutGraph__Yap7K`,
	"overviewGraphDropDown": `ParticipantAssessments_overviewGraphDropDown__PutNO`,
	"graphHelper": `ParticipantAssessments_graphHelper__CfXjO`,
	"completedLayout": `ParticipantAssessments_completedLayout__a46OH`,
	"completedLayoutHeader": `ParticipantAssessments_completedLayoutHeader__gIju5`,
	"headerCompletedAssessments": `ParticipantAssessments_headerCompletedAssessments__LYDFs`,
	"completedLayoutFilters": `ParticipantAssessments_completedLayoutFilters__JGtfK`,
	"completedLayoutRefresh": `ParticipantAssessments_completedLayoutRefresh__jywZi`,
	"completedLayoutBody": `ParticipantAssessments_completedLayoutBody__nJMxn`,
	"completedComponent": `ParticipantAssessments_completedComponent__AjQZB`,
	"actionButton": `ParticipantAssessments_actionButton__JHay2`,
	"filterButtonText": `ParticipantAssessments_filterButtonText__vvdnr`,
	"filterDialog": `ParticipantAssessments_filterDialog__Zahmp`,
	"filterControl": `ParticipantAssessments_filterControl__LdxHy`,
	"filterLayout": `ParticipantAssessments_filterLayout__Ebmo2`,
	"filterLayoutSchedule": `ParticipantAssessments_filterLayoutSchedule__hG2kt`,
	"filterLayoutFromScheduleCompleted": `ParticipantAssessments_filterLayoutFromScheduleCompleted__J+KUg`,
	"filterLayoutFromScheduleCompletedInput": `ParticipantAssessments_filterLayoutFromScheduleCompletedInput__p76gW`,
	"filterLayoutFromScheduleUpcoming": `ParticipantAssessments_filterLayoutFromScheduleUpcoming__3Q+Tx`,
	"filterLayoutFromScheduleUpcomingInput": `ParticipantAssessments_filterLayoutFromScheduleUpcomingInput__vMOJ8`,
	"filterLayoutFrom": `ParticipantAssessments_filterLayoutFrom__+vUOh`,
	"filterLayoutTo": `ParticipantAssessments_filterLayoutTo__zycQ-`,
	"filterLayoutSearch": `ParticipantAssessments_filterLayoutSearch__BrTVs`,
	"filterLayoutReset": `ParticipantAssessments_filterLayoutReset__T9rbF`,
	"filterLayoutButtons": `ParticipantAssessments_filterLayoutButtons__AZw-f`,
	"blockDialog": `ParticipantAssessments_blockDialog__A-gEM`,
	"blockFooter": `ParticipantAssessments_blockFooter__GCeb8`,
	"buttonGroup": `ParticipantAssessments_buttonGroup__yNYQT`,
	"InfoOverlayIconContainer": `ParticipantAssessments_InfoOverlayIconContainer__q0jAU`,
	"InfoOverlay": `ParticipantAssessments_InfoOverlay__BWrJ7`,
	"InfoOverlayText": `ParticipantAssessments_InfoOverlayText__a5uWj`,
	"refreshContainer": `ParticipantAssessments_refreshContainer__uq4UL`,
	"refreshButton": `ParticipantAssessments_refreshButton__dYZSw`,
	"refreshBadge": `ParticipantAssessments_refreshBadge__eR3Ik`,
	"viewSelect": `ParticipantAssessments_viewSelect__LJ7kl`,
	"tabView": `ParticipantAssessments_tabView__qS1tW`,
	"tabViewMobile": `ParticipantAssessments_tabViewMobile__22N4A`,
	"tabButtonContainer": `ParticipantAssessments_tabButtonContainer__Oqbxa`,
	"viewButton": `ParticipantAssessments_viewButton__ZCS9H`,
	"viewButtonContent": `ParticipantAssessments_viewButtonContent__awsPe`,
	"viewButtonContentSelected": `ParticipantAssessments_viewButtonContentSelected__dhy1f`
};
export default ___CSS_LOADER_EXPORT___;
